/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import quotationMark from "assets/graphics/icons/quote.svg";
import parlor from "assets/graphics/icons/parlor.svg";

import "features/new/recommendation/component/view.scss";
import { AnimatePresence, motion } from "framer-motion";
import { wrap } from "popmotion";

const variants = {
  enter: () => {
    return {
      x: 1000,
      position: "absolute",
    };
  },
  center: {
    x: 0,
    position: "static",
  },
  exit: () => ({
    x: -1000,
    position: "absolute",
  }),
};

const RecommendationView = ({ recommendations, recommendationReference }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const recommendationIndex = wrap(0, recommendations.length, currentSlide);

  const nextSlide = () => {
    if (currentSlide < recommendations.length) {
      setCurrentSlide((prev) => prev + 1);
    } else {
      setCurrentSlide(0);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <section className="main__recommendation main__animation--fade-in">
      <blockquote
        className="recommendation__container"
        ref={recommendationReference}
      >
        <AnimatePresence initial={false}>
          <motion.div
            key={currentSlide}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ x: { duration: 0.3 } }}
            style={{ position: "absolute", width: "100%" }}
            className={classnames({
              recommendation__slide: true,
              "recommendation__slide--flipped":
                recommendations[recommendationIndex].quotation_mark_position ===
                "bottom",
            })}
          >
            <div className="recommendation__content">
              <img
                className="recommendation__quotation-mark"
                src={quotationMark}
                alt="quotation mark"
              />
              <p className="recommendation__text">
                &quot;{recommendations[recommendationIndex].content}&quot;
              </p>
            </div>
            {!recommendations[recommendationIndex].isMember && (
              <figure className="recommendation__author">
                <img
                  src={recommendations[recommendationIndex].author_image_url}
                  alt={recommendations[recommendationIndex].author_name}
                />
              </figure>
            )}
            {recommendations[recommendationIndex].isMember && (
              <figure className="recommendation__author recommendation__author--slim">
                <div className="recommendation__picture">
                  <img src={parlor} alt="" />
                </div>
                <figcaption className="recommendation__name">
                  {/* eslint-disable-next-line react/no-unescaped-entities */}
                  {recommendations[recommendationIndex].author_name}
                </figcaption>
              </figure>
            )}
          </motion.div>
        </AnimatePresence>
      </blockquote>
    </section>
  );
};

RecommendationView.propTypes = {
  recommendations: PropTypes.instanceOf(Array).isRequired,
  recommendationReference: PropTypes.object,
};

export default RecommendationView;
